import { memo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectIsPaused, setShowPreviewImages } from "@app/player/playerSlice";
import SvgPlay from "@assets/images/player/SvgPlay.jsx";
import SvgRewind from "@assets/images/player/SvgRewind";
import SvgForward from "@assets/images/player/SvgForward";
import SvgPause from "@assets/images/player/SvgPause";
import { useTranslation } from "react-i18next";
import "../styles/ArchiveButtons.scss";
import useKeydown from "@hooks/useKeydown";
import { setCtrl } from "@app/global";

export default memo(function ArchiveButtons({
  play,
  pause,
  active,
  setActive,
  isPaused,
  changeChannel,
  actionHandler,
  showControlHandler,
  type,
  hideControls,
  changeChangelWithNumber,
  hasArchive,
  isArchiveLoaded,
  onBackHandler,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(3);

  const handleClick = (e) => {
    if (hideControls) return showControlHandler();

    if (isPaused) play();
    else pause();
  };

  useKeydown({
    isActive: active,
    up: () => {
      if (hideControls) return showControlHandler();

      // setActiveIndex(0);
      changeChannel("next");
    },
    down: () => {
      // setActiveIndex(0);

      changeChannel("prev");
    },
    left: () => {
      if (hideControls) return showControlHandler();

      if (!hasArchive && type === "live") {
        setActive(1);
        dispatch(setCtrl("live"));
        return;
      }

      if (activeIndex === 0) {
        setActive(5);
        dispatch(setCtrl("live"));
        return;
      }
      setActiveIndex(activeIndex - 1);
      showControlHandler();
    },
    right: () => {
      if (hideControls) return showControlHandler();

      if (!hasArchive && type === "live") {
        return;
      }

      if (hasArchive && activeIndex === 6) {
        setActive(false);
        // dispatch(setCtrl("archiveBtns"));
        return;
      }

      setActiveIndex(activeIndex + 1);
      showControlHandler();
    },

    ok: () => {
      if (hideControls) return showControlHandler();
      showControlHandler();

      // if(!isArchiveLoaded) return;

      if (activeIndex === 3) {
        handleClick();
      } else {
        actionHandler(activeIndex);
      }
    },

    number: (e) => {
      changeChangelWithNumber(e.key);
    },

    back: () => {
      onBackHandler();
    },
  });

  return (
    <div className="archive-buttons_wrapper">
      <div
        className={`buttons-group-live ${!hasArchive && type === "live" ? "no-archive" : "has-archive"}`}
      >
        {hasArchive ? (
          <div
            className={`rewind btn-group-live ${activeIndex === 0 && active ? "active" : ""}`}
            data-testid="rewind-10m-button"
          >
            <p className="archive-btn_text">-10 {t("M")}</p>
            <SvgRewind />
          </div>
        ) : null}
        {hasArchive ? (
          <div
            className={`rewind btn-group-live ${activeIndex === 1 && active ? "active" : ""}`}
            data-testid="rewind-5m-button"
          >
            <p className="archive-btn_text">-5 {t("M")}</p>
            <SvgRewind />
          </div>
        ) : null}
        {hasArchive ? (
          <div
            className={`rewind btn-group-live ${activeIndex === 2 && active ? "active" : ""}`}
            data-testid="rewind-1m-button"
          >
            <p className="archive-btn_text">-1 {t("M")}</p>
            <SvgRewind />
          </div>
        ) : null}
        <div
          className={`play-pause btn-group-live ${activeIndex === 3 && active ? "active" : ""}`}
          onClick={handleClick}
          data-testid="play-pause-button"
        >
          {isPaused ? <SvgPlay /> : <SvgPause />}
        </div>
        {hasArchive ? (
          <div
            className={`forward btn-group-live ${activeIndex === 4 && active ? "active" : ""}`}
            data-testid="forward-1m-button"
          >
            <SvgForward />
            <p className="archive-btn_text">+1 {t("M")}</p>
          </div>
        ) : null}
        {hasArchive ? (
          <div
            className={`forward btn-group-live ${activeIndex === 5 && active ? "active" : ""}`}
            data-testid="forward-5m-button"
          >
            <SvgForward />
            <p className="archive-btn_text">+5 {t("M")}</p>
          </div>
        ) : null}
        {hasArchive ? (
          <div
            className={`forward btn-group-live ${activeIndex === 6 && active ? "active" : ""}`}
            data-testid="forward-10m-button"
          >
            <SvgForward />
            <p className="archive-btn_text">+10 {t("M")}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
});
